import { useEffect } from 'react';
import { getDictionaryText } from '../getDictionaryText';

/* This hook will take javascript URL as parameter and load the script after component will mount asynchronously. 
It will also remove the script on component unmount.*/

export const createScript = (url, isAsync = true) => {
  // Return if url is undefined or not passed
  if (!url) return '';

  const script = document.createElement('script');
  script.src = url;
  script.async = isAsync;
  document.body.appendChild(script);

  return script;
};

export const deleteScript = script => {
  script && document.body.removeChild(script);
};

const useScript = (url, toggleScript) => {
  const headerScript = getDictionaryText('3DSocialShareHeaderScript')
  useEffect(() => {
    if (toggleScript) createScript(headerScript)
    const script = createScript(url);

    return () => {
      deleteScript(script);
      if (toggleScript) deleteScript(headerScript);
    };
  }, [url]);
};

export default useScript;
